import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import {SearchFilterModule} from '../../components/search-filter/search-filter.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { CreateCustomImageComponent } from './create-custom-image.component/create-custom-image.component';
import { TenantCustomImageComponent } from './tenant-custom-image.component';
import { TenantCustomImageRoutingModule } from './tenant-custom-image-routing.module';
import { AddCustomImageComponent } from './add-custom-image.component/add-custom-image.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ErrorModule} from 'src/app/components/error/error.module';
import { MonacoEditorModule } from '@vality/ng-monaco-editor';
import {TableModule} from 'src/app/table/table.module';
import { CommonTableModule } from 'src/app/components/table/table.module';
import { TenantCustomImageDetailsComponent } from '../tenant-custom-image-details/tenant-custom-image-details.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@NgModule({
  declarations: [
    TenantCustomImageComponent,
    CreateCustomImageComponent,
    AddCustomImageComponent,
    TenantCustomImageDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    BreadcrumbModule,
    TenantCustomImageRoutingModule,
    SearchFilterModule,
    PaginatorModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatCardModule,
    MatSelectModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorModule,
    MonacoEditorModule,
    TableModule,
    CommonTableModule,
    NgxSkeletonLoaderModule
  ]
})
export class TenantCustomImageModule { }
